module.exports = __webpack_public_path__ + "img/rbcn_pro_show_3.c2f4fe3e.jpg";